import './index.css';

export default {
  name: 'Atypewriter',
  props: {
    id: { type: String, default: () => (`a-typewriter-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 10 }, // 输出速度(值越小越快)
    text: { type: String, default: () => null },
    value: { type: String, default: () => null },
    values: { type: String, default: () => null },
    content: { type: String, default: () => null },
    context: { type: String, default: () => null },
  },
  data() {
    return ({
      timeout: null,
    });
  },
  watch: {
    text() { this.create() },
    value() { this.create() },
    values() { this.create() },
    content() { this.create() },
    context() { this.create() },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        const text = this.context || this.content || this.values || this.value || this.text;
        let value = text.replace(/<[^>]*>/g, '');
        let index = 0;
        const write = () => {
          if (index < value.length) {
            this.$el.innerHTML += value[index];
            index++;
            this.cancel();
            this.$nextTick(() => this.timeout = setTimeout(write, parseInt(this.speed)));
          }
        }
        write();
      });
    },
    cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => this.$el.innerHTML = '');
    },
  },
  render() {
    const { width, height, padding, margin } = this.$attrs;
    return (<div class="a-typewriter" id={this.id} style={{ width, height, padding, margin }} />);
  }
}